export default "__VITE_ASSET__DiGP3x2___"